// HappyHorse 1.1 promo — STU-8440. This is a TEMPORARY banner: it is removed
// manually (and this whole `ai-video-promo` folder deleted) on Monday
// 2026-07-06. The end date below doubles as a safety net so the banner
// self-hides if the manual removal slips — see `isAiVideoPromoActive`.
//
// 10:00 Europe/Amsterdam (CEST, UTC+2) on Monday 6 July 2026.
export const AI_VIDEO_PROMO_END_DATE = new Date('2026-07-06T10:00:00+02:00')

/**
 * GrowthBook flag that turns the whole HappyHorse 1.1 AI-video promo on/off —
 * both the banner and the model-selector badge read it through
 * `isAiVideoPromoActive`. STU-8448.
 */
export const AI_VIDEO_PROMO_FEATURE_FLAG = 'STU-8448-video-model-promo-badge'

/**
 * The promo is active only when its GrowthBook flag is on AND we're still before
 * the end date — the date is the safety net so it self-hides if the flag is left
 * enabled past the window. Read imperatively (not via `useFeatureIsOn`) so this
 * stays a plain predicate usable from both the banner render and the model
 * adapter without a hook.
 */
export function isAiVideoPromoActive(): boolean {
  const flagOn = window.globalGrowthBook?.isOn(AI_VIDEO_PROMO_FEATURE_FLAG) ?? false
  return flagOn && Date.now() < AI_VIDEO_PROMO_END_DATE.getTime()
}

/** localStorage key remembering that the user dismissed the promo banner. */
export const AI_VIDEO_PROMO_DISMISSED_KEY = 'studio_hh11_promo_dismissed'
